/**
 * Popup "Log masuk Flow tidak berjaya" — page Flow Google, pelanggan Flow JENIS 2 (2026-10-03).
 *
 * Dahulu sebab gagal hanya satu baris merah kecil di bawah butang Open Flow — mudah terlepas pandang,
 * dan pelanggan tidak tahu apa perlu dibuat. Popup ini memapar ayat sebab (utils/flowT2Ralat.js),
 * butang "Cuba semula" (Open Flow sekali lagi) dan "Hubungi admin" (WhatsApp, mesej siap dengan kod).
 * Rupa v3.9: monokrom, tiada emoji.
 */
import { useEffect } from 'react';
import { X } from 'lucide-react';
import { useT } from '../i18n';
import { Btn, IconBtn } from '../design/ui';
import { ayatRalatT2, kodT2Sah } from '../utils/flowT2Ralat';

// TWIN: FlowPayView.jsx WHATSAPP_ADMIN (nombor admin Flow yang sama).
const WHATSAPP_ADMIN = '601135011231';

export default function FlowGagalLogin({ kod, emel, busy, onRetry, onClose }) {
    const t = useT();
    useEffect(() => {
        const tekan = e => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', tekan);
        return () => window.removeEventListener('keydown', tekan);
    }, [onClose]);
    if (!kodT2Sah(kod)) return null;

    // Mesej WhatsApp: kod + emel akaun SESAAT sahaja (tiada Gmail Flow / kata laluan — pelanggan tidak memegangnya).
    const mesej = t('fc.t2.err.waText', { kod, emel: emel || '-' });
    const wa = `https://wa.me/${WHATSAPP_ADMIN}?text=${encodeURIComponent(mesej)}`;

    return (
        <div className="fc-gl-bg" onClick={onClose}>
            <div className="fc-gl" role="dialog" aria-modal="true" aria-labelledby="fc-gl-tajuk" onClick={e => e.stopPropagation()}>
                <div className="fc-gl-kepala">
                    <h2 id="fc-gl-tajuk">{t('fc.t2.err.title')}</h2>
                    <IconBtn label={t('fc.t2.err.close')} icon={<X size={16} />} onClick={onClose} />
                </div>
                <p className="fc-gl-ayat">{ayatRalatT2(kod, t)}</p>
                <div className="fc-gl-butang">
                    <a className="s-btn s-btn--ghost" href={wa} target="_blank" rel="noopener noreferrer">{t('fc.t2.err.contact')}</a>
                    <Btn disabled={busy} onClick={onRetry}>{busy ? t('fc.preparing') : t('fc.t2.err.retry')}</Btn>
                </div>
            </div>
        </div>
    );
}
